// React import
import React from 'react';
import  { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { unsetAiNewText } from "../../actions";
// Styles imports
import './AiCircle.css';
import '../../util.css'
// Consts imports
import {
    AI_CHECK_WALLET_ERROR,
    AI_CHECK_WALLET_PROCESSING,
    AI_CHECK_WALLET_WELCOME,
    AI_FIRST_WELCOME,
    AI_TOKEN_ANALYZER_PROCESSING,
    AI_TOKEN_ANALYZER_WELCOME
} from "../../consts/consts";

const Typewriter = ({ text, delay = 100, pauseDelay = 10 , phrasesDelay = 10,
                        isNewText, unsetAiNewText}) => {

    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [pauseIndex, setPauseIndex] = useState(0);
    const [isPause, setPause] = useState(false);

    useEffect(() => {

        if(isNewText) {
            setCurrentText('');
            setCurrentIndex(0);
            setPauseIndex(0);
            setPause(false);
            unsetAiNewText();
        }

        if (currentIndex === 0 && pauseIndex < pauseDelay) {
            const timeout = setTimeout(() => {
                setPauseIndex(prevPauseIndex => prevPauseIndex + 1);
            }, delay);
            return () => clearTimeout(timeout);
        }

        if(text[currentIndex] === '¦' && pauseIndex < phrasesDelay && isPause) {
            const timeout = setTimeout(() => {
                setPauseIndex(prevPauseIndex => prevPauseIndex + 1);
            }, delay);
            return () => clearTimeout(timeout);
        } else if (text[currentIndex] === '¦' && pauseIndex === phrasesDelay && isPause) {
            setCurrentIndex(prevIndex => prevIndex + 1);/**/
            setPause(false);
            setCurrentText("");
        }

        if (currentIndex < text.length) {
            if(text[currentIndex] === '¦') {
                setPauseIndex(0);
                setPause(true);
            } else {
                const timeout = setTimeout(() => {
                    setCurrentText(prevText => prevText + text[currentIndex]);
                    setCurrentIndex(prevIndex => prevIndex + 1);
                }, delay);
                return () => clearTimeout(timeout);
            }
        }
    }, [currentIndex, delay, text, pauseIndex, pauseDelay]);

    return <p className="t1 text new-line">{currentText}</p>;
};

class AiCircle extends React.Component {

    getAiCirclePosition = (position) => {
        if(position === AI_CHECK_WALLET_WELCOME) {
            return("ai-circle_check-wallet")
        } else if(position === AI_TOKEN_ANALYZER_WELCOME) {
            return("ai-circle_check-wallet");
        }  else if(position === AI_CHECK_WALLET_ERROR) {
            return("ai-circle_check-wallet");
        }  else if(position === AI_CHECK_WALLET_PROCESSING) {
            return("ai-circle_check-wallet");
        } else if(position === AI_TOKEN_ANALYZER_PROCESSING) {
            return("ai-circle_check-wallet");
        } else if(position === AI_FIRST_WELCOME) {
            return("ai-circle");
        } else {
            return("ai-circle");
        }
    }

    render () {

        const { text, status, isNewText } = this.props.aiCircle;
        const { position } = this.props;
        const { unsetAiNewText } = this.props;

        return(
            <div className={this.getAiCirclePosition(position) + " noselect"}>
                <div className={"wrap"}>
                    <div className="box_wrap">
                        <div className="box_rotate bg1"></div>
                        <div className="box_rotate bg2"></div>
                        <div className="box_txt">
                            <div>
                                <Typewriter
                                    text={text}
                                    status={status}
                                    pauseDelay={5}
                                    phrasesDelay={10}
                                    isNewText={isNewText}
                                    unsetAiNewText={unsetAiNewText}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}



const mapStateToProps = ({ aiCircle }) => {
    return { aiCircle };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        unsetAiNewText: unsetAiNewText,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AiCircle);